<template>
  <div id="left-menu">
    <v-navigation-drawer
      class="v-navigation-drawer"
      v-model="drawer"
      :width="300"
      :mini-variant-width="100"
      :mini-variant="true"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      :expand-on-hover="true"
      :floating="true"
    >
      <aside>
        <v-list-item class="nav-header" v-if="false">
          <v-list-item-avatar>
            <a href="/">
              <img
                class="d-none d-md-block"
                :src="logoSm"
                width="150px"
                alt="ProMate"
              />
            </a>
          </v-list-item-avatar>
          <v-list-item-title class="text-h6 font-weight-medium">Promate</v-list-item-title>
        </v-list-item>

        <v-divider></v-divider>
        <v-list dense nav class="overflow-y-auto ps-0" max-height="750">
          <v-list-item
            link
            v-for="item in MenuItems"
            :key="item.text"
            :to="item.link"
            :class="
              item.activePath === $route.meta.activePath
                ? 'v-list-item--active'
                : ''
            "
          >
            <v-list-item-icon>
              <v-icon size="35">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="text-h6 py-5">{{
              item.text
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </aside>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data: () => ({
    logo: require("@/assets/logo.png"),
    logoSm: require("@/assets/promate-software-logo-sm.png"),
    items: [
      { icon: "mdi-home", text: "Home", link: "/", activePath: "/" },

      {
        icon: "mdi-lightbulb-on",
        text: "Jobs",
        link: "/projects",
        activePath: "projects",
      },
      {
        icon: "mdi-account-multiple-plus",
        text: "Clients",
        link: "/customers",
        activePath: "customers",
      },
      {
        icon: "mdi-account-multiple",
        text: "System Users",
        link: "/employers",
        activePath: "employers",
      },
      {
        icon: "mdi-chart-line",
        text: "Reports",
        link: "/reports",
        activePath: "reports",
      },
      {
        icon: "mdi-invoice",
        text: "Invoices",
        link: "/invoices",
        activePath: "invoices",
      },
      {
        icon: "mdi-shield-account",
        text: "Roles and Permissions",
        link: "/roles",
        activePath: "roles",
      },
    ],
    // MenuItems:[]
  }),

  props: {
    // dataArray: {
    //   type: Array,
    //   required: true,
    // },
    MenuItems: {
      type: Array,
      required: true,
    },
  },

  computed: {
    drawer: {
      get() {
        return this.$store.state.auth.drawer;
      },
      set(value) {
        this.$store.commit("auth/setDrawer", value);
      },
    },
  },

  watch: {
    drawer(value) {
      this.toggleNav(value);
    },

    // dataArray: function(newDataArray, oldDataArray) {
    //   if (newDataArray !== oldDataArray) {
    //     this.MenuItems = this.dataArray;
    //   }
    // },
  },

  methods: {
    toggleNav: function(value) {
      this.$store.dispatch("auth/changeDrawer", value);
    },
  },
};
</script>
